import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const PATIENT = {
  id: 'admin.khuyana.patient',
  title: 'Administración de Pacientes',

  labels: {
    ...COMMONS,
    clinicHistory: 'Historia clínica',
    age: 'Edad',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    residence: 'Residencia',
    residencePlaceholder: 'Lugar de residencia...',
    addressPlaceholder: 'Dirección...',
  },

  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Paciente`,
    edit: `${ACTIONS.edit} Paciente`,
  }
};
